<script lang="ts" setup></script>
<template>
  <nav>
    <ul>
      <li>
        <RouterLink to="/">Home</RouterLink>
      </li>
      <li>
        <RouterLink to="/programma">Programma</RouterLink>
      </li>
      <!-- <li>
        <RouterLink to="/plattegrond">Plattegrond</RouterLink>
      </li> -->
    </ul>
  </nav>
</template>
